/* Collection UI runtime. Liquid settings are supplied by #VerychiCollectionRuntimeConfig. */
/* ── Mobile grid toggle (2-col ↔ 1-col) ── */
(function() {
  var MOB_KEY = 'cqa_grid_cols';
  var DESK_KEY = 'cqa_desk_cols';
  var mobSaved = localStorage.getItem(MOB_KEY);
  var deskSaved = localStorage.getItem(DESK_KEY);
  var toggle = document.getElementById('CqaGridToggle');
  if (!toggle) return;
  var grid = document.querySelector('.collection-products');
  if (!grid) return;
  var mobBtns = toggle.querySelectorAll('.cqa-grid-toggle__btn[data-device="mobile"]');
  var deskBtns = toggle.querySelectorAll('.cqa-grid-toggle__btn[data-device="desktop"]');

  function updateNativeImageSizes() {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var size = '25vw';
    if (isMobile) size = grid.classList.contains('cqa-one-col') ? '100vw' : '50vw';
    else if (grid.classList.contains('cqa-desk-cols-2')) size = '50vw';
    else if (grid.classList.contains('cqa-desk-cols-3')) size = '33.333vw';

    var images = grid.querySelectorAll('img[class*="ProductImage-"][srcset]');
    for (var i = 0; i < images.length; i++) images[i].setAttribute('sizes', size);
  }
  window.__cqaUpdateImageSizes = updateNativeImageSizes;

  /* ── Mobile: 2-col (default) / 1-col ── */
  function applyMobile(cols) {
    if (cols === '1') {
      grid.classList.add('cqa-one-col');
    } else {
      grid.classList.remove('cqa-one-col');
      cols = '2';
    }
    for (var i = 0; i < mobBtns.length; i++) {
      mobBtns[i].classList.toggle('cqa-grid-toggle__btn--active', mobBtns[i].getAttribute('data-cols') === cols);
    }
    updateNativeImageSizes();
    localStorage.setItem(MOB_KEY, cols);
  }

  /* ── Desktop: 4-col (default) / 3-col / 2-col ── */
  function applyDesktop(cols) {
    grid.classList.remove('cqa-desk-cols-2', 'cqa-desk-cols-3');
    if (cols === '2') grid.classList.add('cqa-desk-cols-2');
    else if (cols === '3') grid.classList.add('cqa-desk-cols-3');
    else cols = '4'; /* default */
    for (var i = 0; i < deskBtns.length; i++) {
      deskBtns[i].classList.toggle('cqa-grid-toggle__btn--active', deskBtns[i].getAttribute('data-cols') === cols);
    }
    updateNativeImageSizes();
    localStorage.setItem(DESK_KEY, cols);
  }

  /* Restore saved preferences */
  if (mobSaved) applyMobile(mobSaved);
  if (deskSaved) applyDesktop(deskSaved);
  updateNativeImageSizes();

  for (var i = 0; i < mobBtns.length; i++) {
    mobBtns[i].addEventListener('click', function() {
      applyMobile(this.getAttribute('data-cols'));
    });
  }
  for (var i = 0; i < deskBtns.length; i++) {
    deskBtns[i].addEventListener('click', function() {
      applyDesktop(this.getAttribute('data-cols'));
    });
  }
})();

/* ── Editorial image cards: match the height of two product photos ── */
(function() {
  var resizeTimer = null;
  var mutationTimer = null;

  function parsePx(value) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  function getGridRowGap(grid) {
    var styles = window.getComputedStyle(grid);
    return parsePx(styles.rowGap) || parsePx(styles.gap) || parsePx(styles.getPropertyValue('--cqa-row-gap'));
  }

  function getProductSample(grid) {
    var cards = grid.children;
    for (var i = 0; i < cards.length; i++) {
      if (!cards[i].classList || !cards[i].classList.contains('grid-product')) continue;
      if (cards[i].classList.contains('cqa-page-card') || cards[i].classList.contains('cqa-image-card')) continue;
      if (cards[i].offsetParent === null) continue;
      if (cards[i].getBoundingClientRect().height > 0) return cards[i];
    }
    return null;
  }

  function getProductPhotoHeight(productCard) {
    var imageWrapper = productCard.querySelector('.grid-product__image-wrapper');
    if (imageWrapper && imageWrapper.getBoundingClientRect().height > 0) {
      return Math.ceil(imageWrapper.getBoundingClientRect().height);
    }

    var productWrapper = productCard.querySelector('.product--wrapper');
    if (productWrapper && productWrapper.getBoundingClientRect().height > 0) {
      return Math.ceil(productWrapper.getBoundingClientRect().height);
    }

    return Math.ceil(productCard.getBoundingClientRect().height);
  }

  function getImageCardFillEls(card) {
    return card.querySelectorAll('.grid-product__wrapper, .grid-product__image-wrapper, .grid-product__image-link, .product--wrapper, .cqa-image-card__media');
  }

  function resetImageCardForMeasure(card) {
    var fillEls = getImageCardFillEls(card);
    card.classList.remove('cqa-image-card--measured');
    card.style.height = '';
    card.style.minHeight = '';
    card.style.overflow = '';

    for (var i = 0; i < fillEls.length; i++) {
      fillEls[i].style.height = '';
      fillEls[i].style.minHeight = '';
    }

    var media = card.querySelector('.cqa-image-card__media');
    if (media) {
      media.style.paddingTop = '';
    }
  }

  function applyImageCardHeight(card, targetHeight) {
    var fillEls = getImageCardFillEls(card);
    card.style.setProperty('--cqa-image-card-height', targetHeight + 'px');
    card.style.height = targetHeight + 'px';
    card.style.minHeight = targetHeight + 'px';
    card.style.overflow = '';
    card.classList.add('cqa-image-card--measured');

    for (var i = 0; i < fillEls.length; i++) {
      fillEls[i].style.height = '100%';
      fillEls[i].style.minHeight = '100%';
    }

    var media = card.querySelector('.cqa-image-card__media');
    if (media) {
      media.style.paddingTop = '0px';
    }
  }

  function getImageCards(grid) {
    var cards = [];
    for (var i = 0; i < grid.children.length; i++) {
      if (grid.children[i].classList && grid.children[i].classList.contains('cqa-image-card')) {
        cards.push(grid.children[i]);
      }
    }
    return cards;
  }

  function getProductPhotos(grid) {
    var photos = [];
    var cards = grid.children;
    for (var i = 0; i < cards.length; i++) {
      if (!cards[i].classList || !cards[i].classList.contains('grid-product')) continue;
      if (cards[i].classList.contains('cqa-page-card') || cards[i].classList.contains('cqa-image-card')) continue;

      var imageWrapper = cards[i].querySelector('.grid-product__image-wrapper');
      if (!imageWrapper || imageWrapper.offsetParent === null) continue;

      var rect = imageWrapper.getBoundingClientRect();
      if (rect.height <= 0 || rect.width <= 0) continue;

      photos.push({
        top: rect.top,
        bottom: rect.bottom,
        height: rect.height
      });
    }

    return photos.sort(function(a, b) {
      return a.top - b.top;
    });
  }

  function getPhotoRows(photos) {
    var rows = [];
    var tolerance = 8;
    for (var i = 0; i < photos.length; i++) {
      var row = rows.length ? rows[rows.length - 1] : null;
      if (!row || Math.abs(row.top - photos[i].top) > tolerance) {
        rows.push({
          top: photos[i].top,
          bottom: photos[i].bottom
        });
      } else {
        row.top = Math.min(row.top, photos[i].top);
        row.bottom = Math.max(row.bottom, photos[i].bottom);
      }
    }
    return rows;
  }

  function getTargetHeightFromRows(card, rows, fallbackHeight) {
    var cardTop = card.getBoundingClientRect().top;
    var tolerance = 10;
    var firstRowIndex = -1;

    for (var i = 0; i < rows.length; i++) {
      if (rows[i].top >= cardTop - tolerance) {
        firstRowIndex = i;
        break;
      }
    }

    if (firstRowIndex > -1 && rows[firstRowIndex + 1]) {
      return Math.max(1, Math.ceil(rows[firstRowIndex + 1].bottom - cardTop));
    }

    return fallbackHeight;
  }

  function measureImageCards() {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var grids = document.querySelectorAll('.collection-products');
    for (var i = 0; i < grids.length; i++) {
      var grid = grids[i];
      var imageCards = getImageCards(grid);
      if (!imageCards.length) continue;

      if (isMobile) {
        for (var mobileIndex = 0; mobileIndex < imageCards.length; mobileIndex++) {
          resetImageCardForMeasure(imageCards[mobileIndex]);
        }
        continue;
      }

      var productSample = getProductSample(grid);
      if (!productSample) continue;

      var productPhotoHeight = getProductPhotoHeight(productSample);
      if (!productPhotoHeight) continue;

      var rows = getPhotoRows(getProductPhotos(grid));
      var fallbackHeight = Math.ceil((productPhotoHeight * 2) + getGridRowGap(grid));
      for (var j = 0; j < imageCards.length; j++) {
        var targetHeight = getTargetHeightFromRows(imageCards[j], rows, fallbackHeight);
        if (!targetHeight || !isFinite(targetHeight) || targetHeight < 80) {
          targetHeight = fallbackHeight;
        }
        applyImageCardHeight(imageCards[j], targetHeight);
      }
    }
  }

  function scheduleMeasure() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measureImageCards, 80);
  }

  function scheduleMutationMeasure() {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(measureImageCards, 120);
  }

  document.addEventListener('DOMContentLoaded', scheduleMeasure);
  window.addEventListener('load', function() {
    scheduleMeasure();
    setTimeout(measureImageCards, 350);
    setTimeout(measureImageCards, 1000);
  });
  window.addEventListener('resize', scheduleMeasure);
  document.addEventListener('shopify:section:load', scheduleMeasure);
  document.addEventListener('shopify:section:select', scheduleMeasure);
  window.__cqaMeasureImageCards = measureImageCards;

  var toggle = document.getElementById('CqaGridToggle');
  if (toggle) {
    toggle.addEventListener('click', function() {
      setTimeout(measureImageCards, 100);
    });
  }

  var grid = document.querySelector('.collection-products');
  if (grid && window.MutationObserver) {
    new MutationObserver(scheduleMutationMeasure).observe(grid, { childList: true });
  }

  scheduleMeasure();
})();

/* ── Filter drawer (mobile + desktop) ── */
(function() {
  var FILTER_KEY = 'cqa_filters_' + (window.location.pathname.replace(/\//g, '_'));

  /* Detect navigation type: clear filters on reload, keep on back/forward */
  var navType = '';
  try {
    var navEntry = performance.getEntriesByType('navigation')[0];
    if (navEntry) navType = navEntry.type;          /* 'reload' | 'back_forward' | 'navigate' */
  } catch(e) {}
  if (navType === 'reload') {
    try { localStorage.removeItem(FILTER_KEY); } catch(e) {}
  }

  var dataEl = document.getElementById('CqaFilterData');
  var tagEl = document.getElementById('CqaTagFilters');
  var colEl = document.getElementById('CqaColFilters');
  var renameEl = document.getElementById('CqaOptionRenames');
  if (!dataEl) return;
  var raw;
  try { raw = JSON.parse(dataEl.textContent); } catch(e) { return; }

  /* Option rename map from admin blocks */
  var renames = {};
  var reverseRenames = {};
  if (renameEl) { try { renames = JSON.parse(renameEl.textContent); } catch(e) {} }

  /* Direct filter label settings from admin (override blocks) */
  var _runtimeConfig = {};
  var _runtimeConfigEl = document.getElementById('VerychiCollectionRuntimeConfig');
  if (_runtimeConfigEl) {
    try {
      _runtimeConfig = JSON.parse(_runtimeConfigEl.textContent || '{}');
    } catch (e) {}
  }
  var _flSize = Object.prototype.hasOwnProperty.call(_runtimeConfig, 'filterLabelSize') ? _runtimeConfig.filterLabelSize : '';
  var _flColor = Object.prototype.hasOwnProperty.call(_runtimeConfig, 'filterLabelColor') ? _runtimeConfig.filterLabelColor : '';
  if (_flSize) { ['Size','size','SIZE','Размер','размер','РАЗМЕР'].forEach(function(k){ renames[k] = _flSize; }); }
  if (_flColor) { ['Color','color','COLOR','Colour','colour','COLOUR','Цвят','цвят','ЦВЯТ','Цветове','цветове','ЦВЕТОВЕ'].forEach(function(k){ renames[k] = _flColor; }); }

  /* Also auto-rename any option whose lowercased name matches known patterns */
  var _colorNames = ['color','colour','цвят','цветове'];
  var _sizeNames  = ['size','размер'];
  Object.keys(renames).forEach(function(k) { reverseRenames[renames[k]] = k; });

  /* Tag-based filters from admin blocks */
  var tagFilters = [];
  if (tagEl) { try { tagFilters = JSON.parse(tagEl.textContent); } catch(e) {} }

  /* Collection-scoped tag filters */
  var colFilters = [];
  if (colEl) { try { colFilters = JSON.parse(colEl.textContent); } catch(e) {} }

  /* Group tag filters by title */
  var tagGroups = {}, tagOrder = [];
  tagFilters.forEach(function(tf) {
    if (!tf.title || !tf.tag) return;
    if (!tagGroups[tf.title]) { tagGroups[tf.title] = []; tagOrder.push(tf.title); }
    var dup = tagGroups[tf.title].some(function(x) { return x.tag === tf.tag; });
    if (!dup) tagGroups[tf.title].push({ tag: tf.tag, label: tf.tag });
  });

  /* Group collection filters by title */
  var colGroups = {}, colOrder = [];
  colFilters.forEach(function(cf) {
    if (!cf.title || !cf.tag) return;
    if (!colGroups[cf.title]) { colGroups[cf.title] = []; colOrder.push(cf.title); }
    var dup = colGroups[cf.title].some(function(x) { return x.tag === cf.tag; });
    if (!dup) colGroups[cf.title].push({ tag: cf.tag, label: cf.label || cf.tag });
  });

  /* Group by option name, preserve order — merge groups with same lowercased name */
  var groups = {}, order = [], _groupCanon = {};
  raw.forEach(function(it) {
    var gLow = it.g.toLowerCase();
    /* If admin renamed this option, use the renamed version as the canonical key */
    var displayName = renames[it.g] || it.g;
    /* Check if we already have a group for this (case-insensitive) */
    var canonKey = _groupCanon[gLow];
    if (!canonKey) {
      canonKey = displayName;
      _groupCanon[gLow] = canonKey;
      groups[canonKey] = [];
      order.push(canonKey);
      /* Ensure reverse mapping works for all case variants */
      if (renames[it.g]) reverseRenames[canonKey] = it.g;
    }
    var dup = groups[canonKey].some(function(x) { return x.v === it.v; });
    if (!dup) groups[canonKey].push({ v: it.v });
  });

  /* Build drawer UI */
  var body = document.getElementById('CqaFilterBody');
  if (!body) return;

  /* Helper: build a filter group section (accordion) */
  function buildGroup(groupTitle, items, dataType) {
    var sec = document.createElement('div');
    sec.className = 'cqa-filter-group';
    var titleEl = document.createElement('div');
    titleEl.className = 'cqa-filter-group__title';
    var titleText = document.createElement('span');
    titleText.textContent = groupTitle;
    titleText.style.display = 'flex';
    titleText.style.alignItems = 'center';
    var groupBadge = document.createElement('span');
    groupBadge.className = 'cqa-filter-group__badge';
    groupBadge.setAttribute('data-group-badge', groupTitle);
    titleText.appendChild(groupBadge);
    titleEl.appendChild(titleText);
    sec.appendChild(titleEl);
    var wrap = document.createElement('div');
    wrap.className = 'cqa-filter-group__values';
    /* Accordion toggle */
    titleEl.addEventListener('click', function() {
      titleEl.classList.toggle('cqa-filter-group__title--open');
      wrap.classList.toggle('cqa-filter-group__values--open');
    });
    items.forEach(function(it) {
      var btn = document.createElement('button');
      btn.className = 'cqa-filter-val';
      btn.setAttribute('data-group', groupTitle);
      btn.setAttribute('data-val', it.val);
      btn.setAttribute('data-type', dataType);
      btn.textContent = it.label;
      if (dataType === 'tag') {
        /* Global tag → navigate to the collection whose handle matches the tag */
        btn.addEventListener('click', function() {
          window.location.href = '/collections/' + encodeURIComponent(it.val);
        });
      } else {
        btn.addEventListener('click', function() {
          this.classList.toggle('cqa-filter-val--active');
          applyFilters();
        });
      }
      wrap.appendChild(btn);
    });
    sec.appendChild(wrap);
    body.appendChild(sec);
  }

  /* Collect all tags present on current page cards to filter out non-existent tags */
  var allCardTags = {};
  (function() {
    var g = document.querySelector('.collection-products');
    if (!g) return;
    g.querySelectorAll(':scope > .grid-product').forEach(function(card) {
      var t = card.getAttribute('data-tags');
      if (!t) return;
      try {
        JSON.parse(t).forEach(function(tag) { allCardTags[tag.toLowerCase()] = true; });
      } catch(e) {}
    });
  })();

  /* Collection-scoped tag filter groups (only tags matching current products) */
  colOrder.forEach(function(title) {
    var items = colGroups[title]
      .filter(function(c) { return allCardTags[c.tag.toLowerCase()]; })
      .map(function(c) { return { val: c.tag, label: c.label }; });
    if (items.length) buildGroup(title, items, 'coltag');
  });

  /* Global tag-based filter groups (always shown — navigates to /collections/all/{tag}) */
  tagOrder.forEach(function(title) {
    var items = tagGroups[title]
      .map(function(t) { return { val: t.tag, label: t.label }; });
    if (items.length) buildGroup(title, items, 'tag');
  });

  /* Option-based filter groups (with admin renames) */
  order.forEach(function(name) {
    var items = groups[name].map(function(v) { return { val: v.v, label: v.v }; });
    buildGroup(name, items, 'option');
  });

  /* Parse card options from data-filter-opts attribute */
  function cardOpts(card) {
    if (card.__cqaOpts) return card.__cqaOpts;
    var raw = card.getAttribute('data-filter-opts');
    if (!raw) { card.__cqaOpts = {}; return card.__cqaOpts; }
    var pairs;
    try { pairs = JSON.parse(raw); } catch(e) { card.__cqaOpts = {}; return card.__cqaOpts; }
    var map = {};
    pairs.forEach(function(p) {
      if (!map[p.o]) map[p.o] = [];
      if (map[p.o].indexOf(p.v) === -1) map[p.o].push(p.v);
    });
    card.__cqaOpts = map;
    return card.__cqaOpts;
  }

  /* Parse card tags from data-tags attribute */
  function cardTags(card) {
    if (card.__cqaTags) return card.__cqaTags;
    var raw = card.getAttribute('data-tags');
    if (!raw) { card.__cqaTags = []; return card.__cqaTags; }
    try { card.__cqaTags = JSON.parse(raw); }
    catch(e) { card.__cqaTags = []; }
    return card.__cqaTags;
  }

  /* Filtering logic: AND between groups, OR within group */
  var grid = document.querySelector('.collection-products');
  var badge = document.getElementById('CqaFilterBadge');

  function applyFilters() {
    /* Collect active filters, split by type */
    var activeOpts = {}, activeTags = {}, activeColTags = {};
    body.querySelectorAll('.cqa-filter-val--active').forEach(function(b) {
      var g = b.getAttribute('data-group');
      var v = b.getAttribute('data-val');
      var type = b.getAttribute('data-type');
      if (type === 'tag') {
        if (!activeTags[g]) activeTags[g] = [];
        activeTags[g].push(v);
      } else if (type === 'coltag') {
        if (!activeColTags[g]) activeColTags[g] = [];
        activeColTags[g].push(v);
      } else {
        if (!activeOpts[g]) activeOpts[g] = [];
        activeOpts[g].push(v);
      }
    });
    var optKeys = Object.keys(activeOpts);
    var tagKeys = Object.keys(activeTags);
    var colTagKeys = Object.keys(activeColTags);
    var hasAny = optKeys.length > 0 || tagKeys.length > 0 || colTagKeys.length > 0;

    var cards = grid ? grid.querySelectorAll(':scope > .grid-product') : [];
    cards.forEach(function(card) {
      if (card.classList.contains('cqa-page-card') || card.classList.contains('cqa-image-card')) {
        card.style.display = '';
        return;
      }
      if (!hasAny) { card.style.display = ''; return; }

      var show = true;

      /* Check option-based filters (AND between groups, OR within) */
      if (show && optKeys.length) {
        var opts = cardOpts(card);
        for (var i = 0; i < optKeys.length; i++) {
          var grp = optKeys[i];
          var origGrp = reverseRenames[grp] || grp;
          var vals = activeOpts[grp];
          /* Case-insensitive option name lookup */
          var cardVals = opts[origGrp] || [];
          if (!cardVals.length) {
            var origLow = origGrp.toLowerCase();
            for (var oKey in opts) {
              if (oKey.toLowerCase() === origLow) { cardVals = opts[oKey]; break; }
            }
          }
          var match = vals.some(function(v) { return cardVals.indexOf(v) !== -1; });
          if (!match) { show = false; break; }
        }
      }

      /* Check tag-based filters (AND between groups, OR within) */
      if (show && tagKeys.length) {
        var tags = cardTags(card);
        var tagsLower = tags.map(function(t) { return t.toLowerCase(); });
        for (var i = 0; i < tagKeys.length; i++) {
          var grp = tagKeys[i];
          var vals = activeTags[grp];
          var match = vals.some(function(v) { return tagsLower.indexOf(v.toLowerCase()) !== -1; });
          if (!match) { show = false; break; }
        }
      }

      /* Check collection-scoped tag filters (AND between groups, OR within) */
      if (show && colTagKeys.length) {
        var ctags = (tagKeys.length && tags) ? tags : cardTags(card);
        var ctagsLower = ctags.map(function(t) { return t.toLowerCase(); });
        for (var i = 0; i < colTagKeys.length; i++) {
          var grp = colTagKeys[i];
          var vals = activeColTags[grp];
          var match = vals.some(function(v) { return ctagsLower.indexOf(v.toLowerCase()) !== -1; });
          if (!match) { show = false; break; }
        }
      }

      card.style.display = show ? '' : 'none';
    });

    /* Show/hide no-results message */
    var noResultsEl = document.getElementById('CqaNoResults');
    if (noResultsEl) {
      var anyVisible = false;
      cards.forEach(function(c) {
        if (c.classList.contains('cqa-page-card') || c.classList.contains('cqa-image-card')) return;
        if (c.style.display !== 'none') anyVisible = true;
      });
      noResultsEl.style.display = (hasAny && !anyVisible) ? '' : 'none';
    }

    /* Badge count */
    var total = 0;
    var allActive = {};
    body.querySelectorAll('.cqa-filter-val--active').forEach(function(b) {
      var g = b.getAttribute('data-group');
      if (!allActive[g]) allActive[g] = [];
      allActive[g].push(b.getAttribute('data-val'));
    });
    for (var k in allActive) total += allActive[k].length;
    if (badge) {
      badge.textContent = total;
      badge.classList.toggle('cqa-toolbar__badge--visible', total > 0);
    }
    /* Update per-group badges */
    document.querySelectorAll('.cqa-filter-group__badge').forEach(function(gb) {
      var gName = gb.getAttribute('data-group-badge');
      var cnt = allActive[gName] ? allActive[gName].length : 0;
      gb.textContent = cnt;
      gb.classList.toggle('cqa-filter-group__badge--visible', cnt > 0);
    });
    /* Persist to localStorage (include type info) */
    var persist = {};
    body.querySelectorAll('.cqa-filter-val--active').forEach(function(b) {
      var key = b.getAttribute('data-type') + '::' + b.getAttribute('data-group');
      if (!persist[key]) persist[key] = [];
      persist[key].push(b.getAttribute('data-val'));
    });
    try { localStorage.setItem(FILTER_KEY, JSON.stringify(persist)); } catch(e) {}
    if (window.__cqaMeasureImageCards) {
      setTimeout(window.__cqaMeasureImageCards, 80);
    }
  }

  /* Open / close drawer */
  var overlay = document.getElementById('CqaFilterOverlay');
  var drawer = document.getElementById('CqaFilterDrawer');
  var filterBtn = document.getElementById('CqaFilterBtn');
  var closeBtn = document.getElementById('CqaFilterClose');
  var resetBtn = document.getElementById('CqaFilterReset');

  function openFilter() {
    if (overlay) overlay.classList.add('cqa-filter-overlay--visible');
    if (drawer) drawer.classList.add('cqa-filter-drawer--visible');
    document.body.style.overflow = 'hidden';
  }
  function closeFilter() {
    if (overlay) overlay.classList.remove('cqa-filter-overlay--visible');
    if (drawer) drawer.classList.remove('cqa-filter-drawer--visible');
    document.body.style.overflow = '';
  }

  if (filterBtn) filterBtn.addEventListener('click', openFilter);
  if (closeBtn) closeBtn.addEventListener('click', closeFilter);
  if (overlay) overlay.addEventListener('click', closeFilter);
  if (resetBtn) resetBtn.addEventListener('click', function() {
    body.querySelectorAll('.cqa-filter-val--active').forEach(function(b) {
      b.classList.remove('cqa-filter-val--active');
    });
    try { localStorage.removeItem(FILTER_KEY); } catch(e) {}
    applyFilters();
  });

  /* Restore saved filters from localStorage */
  (function restoreFilters() {
    var saved;
    try { saved = JSON.parse(localStorage.getItem(FILTER_KEY)); } catch(e) { return; }
    if (!saved || typeof saved !== 'object') return;
    var any = false;
    body.querySelectorAll('.cqa-filter-val').forEach(function(btn) {
      var type = btn.getAttribute('data-type');
      var g = btn.getAttribute('data-group');
      var v = btn.getAttribute('data-val');
      var key = type + '::' + g;
      if (saved[key] && saved[key].indexOf(v) !== -1) {
        btn.classList.add('cqa-filter-val--active');
        any = true;
      }
    });
    if (any) applyFilters();
  })();

  /* Expose applyFilters for infinite scroll integration */
  window.__cqaApplyFilters = applyFilters;
})();

/* ── Desktop: hover-based variant overlay on product image ── */
(function() {
  if (window.__cqaDesktopHover) return;
  window.__cqaDesktopHover = true;

  var _cache = {};
  var _activeWrap = null;
  var _activeOv = null;
  var _hideTimer = null;
  var _loadingWrap = null;

  function colorIdx(p) {
    var n = ['color','colour','цвят','цветове'];
    for (var i = 0; i < p.options.length; i++) {
      var opt = p.options[i];
      var name = (typeof opt === 'string' ? opt : (opt && opt.name ? opt.name : '')).toLowerCase();
      if (n.indexOf(name) !== -1) return i;
    }
    return -1;
  }
  function sizeIdx(p, ci) {
    for (var i = 0; i < p.options.length; i++) { if (i !== ci) return i; }
    return -1;
  }
  function escapeAttr(value) {
    return String(value || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function deliveryNoteFromProduct(p) {
    var tags = (p && p.tags) || [];
    if (typeof tags === 'string') tags = tags.split(',');
    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i] || '').trim();
      if (tag.indexOf('delivery_note_') === 0) return tag.substring(14).trim();
    }
    return '';
  }

  function buildOverlay(wrap, p, curColor) {
    /* Remove old overlay if any */
    var old = document.querySelector('.dhov');
    if (old) old.parentNode.removeChild(old);

    var ci = colorIdx(p), si = sizeIdx(p, ci);
    var deliveryNote = deliveryNoteFromProduct(p);
    var deliveryAttr = escapeAttr(deliveryNote);
    var variants = p.variants.filter(function(v) {
      return ci === -1 || v.options[ci] === curColor || curColor === '';
    });
    var seen = {}, html = '';
    variants.forEach(function(v) {
      var lbl = (si >= 0 ? v.options[si] : (ci >= 0 ? v.options[ci] : null)) || 'One Size';
      if (seen[lbl]) return; seen[lbl] = true;
      var sold = !v.available;
      html += '<button class="dhov-btn' + (sold ? ' dhov-sold' : '') + '" data-vid="' + v.id + '"';
      if (deliveryAttr) html += ' data-delivery-note="' + deliveryAttr + '"';
      html += '>' + lbl + '</button>';
    });
    if (!html) html = '<span style="font-size:11px;color:#999">Изчерпан</span>';

    var imgEl = wrap.querySelector('.product--wrapper') || wrap.querySelector('.grid-product__image') || wrap;
    var rect = imgEl.getBoundingClientRect();
    var ov = document.createElement('div');
    ov.className = 'dhov';
    ov.style.left = rect.left + 'px';
    ov.style.width = rect.width + 'px';
    /* Bottom of overlay = bottom of actual image */
    ov.style.bottom = (window.innerHeight - rect.bottom) + 'px';
    ov.innerHTML = html;
    document.body.appendChild(ov);

    /* Fade in */
    requestAnimationFrame(function() {
      requestAnimationFrame(function() { ov.classList.add('dhov--visible'); });
    });

    return ov;
  }

  function showOverlay(wrap) {
    clearTimeout(_hideTimer);
    if (_activeWrap === wrap && _activeOv) {
      _activeOv.classList.add('dhov--visible');
      return;
    }
    hideOverlay();

    var handle = wrap.getAttribute('data-product-handle');
    var color = wrap.getAttribute('data-current-color') || '';
    if (!handle) return;

    if (_cache[handle]) {
      _activeOv = buildOverlay(wrap, _cache[handle], color);
      _activeWrap = wrap;
      return;
    }

    _loadingWrap = wrap;
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        _cache[handle] = p;
        /* Only show if mouse is still on this wrapper */
        if (_loadingWrap === wrap) {
          _activeOv = buildOverlay(wrap, p, color);
          _activeWrap = wrap;
        }
      })
      .catch(function() { _loadingWrap = null; });
  }

  function hideOverlay() {
    if (_activeOv) {
      _activeOv.classList.remove('dhov--visible');
      var ov = _activeOv;
      setTimeout(function() { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 250);
    }
    _activeOv = null;
    _activeWrap = null;
    _loadingWrap = null;
  }

  function scheduleHide() {
    _hideTimer = setTimeout(hideOverlay, 120);
  }

  function repositionOverlay() {
    if (!_activeOv || !_activeWrap) return;
    var imgEl = _activeWrap.querySelector('.product--wrapper') || _activeWrap.querySelector('.grid-product__image') || _activeWrap;
    var rect = imgEl.getBoundingClientRect();
    _activeOv.style.left = rect.left + 'px';
    _activeOv.style.width = rect.width + 'px';
    _activeOv.style.bottom = (window.innerHeight - rect.bottom) + 'px';
  }
  var _repositionRaf = 0;
  function scheduleRepositionOverlay() {
    if (_repositionRaf) return;
    _repositionRaf = requestAnimationFrame(function() {
      _repositionRaf = 0;
      repositionOverlay();
    });
  }
  window.addEventListener('scroll', scheduleRepositionOverlay, { passive: true });
  window.addEventListener('resize', scheduleRepositionOverlay, { passive: true });

  function addToCart(vid, btn) {
    var orig = btn.textContent;
    var deliveryNote = btn.getAttribute('data-delivery-note') || '';
    var payload = { id: vid, quantity: 1 };
    if (deliveryNote) payload.properties = { _delivery_note: deliveryNote };
    btn.style.background = '#222'; btn.style.color = '#fff'; btn.textContent = '...';
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) })
    .then(function(r){ if(!r.ok) throw new Error(); return r.json(); })
    .then(function(){
      btn.textContent = '\u2713';
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        document.querySelectorAll('.cart-link__count,.site-header__cart-count,[data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
      });
      setTimeout(function() {
        btn.textContent = orig; btn.style.background = ''; btn.style.color = '';
        if (btn.closest('.dhov')) scheduleHide();
      }, 600);
    })
    .catch(function(){
      btn.className = 'dhov-btn dhov-err'; btn.textContent = '!';
      setTimeout(function(){ btn.className = 'dhov-btn'; btn.textContent = orig; }, 1400);
    });
  }

  /* Hover listeners via event delegation */
  document.addEventListener('mouseover', function(e) {
    if (window.innerWidth <= 768) return;
    var wrap = e.target.closest('.grid-product__image-wrapper[data-product-handle]');
    if (wrap) { showOverlay(wrap); return; }
    /* Keep overlay alive when hovering the overlay itself */
    if (e.target.closest('.dhov')) { clearTimeout(_hideTimer); return; }
  });

  document.addEventListener('mouseout', function(e) {
    if (window.innerWidth <= 768) return;
    var wrap = e.target.closest('.grid-product__image-wrapper[data-product-handle]');
    var ov = e.target.closest('.dhov');
    if (wrap || ov) {
      var related = e.relatedTarget;
      /* Still inside wrapper or overlay? Do nothing */
      if (related && (related.closest('.grid-product__image-wrapper[data-product-handle]') === _activeWrap || related.closest('.dhov'))) return;
      scheduleHide();
    }
  });

  /* Click on variant buttons */
  document.addEventListener('click', function(e) {
    if (window.innerWidth <= 768) return;
    var btn = e.target.closest('.dhov-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('dhov-sold')) return;
    addToCart(parseInt(btn.dataset.vid), btn);
  }, true);
})();

